module.exports = __webpack_public_path__ + "img/04989A_0CE3E4_04D2D5_04C7C8-256px.98d5cbd9.png";